import { AiOutlineClose } from "react-icons/ai";
import CardActionMenu from "../common/ActionMenu/CardActionMenu";
import AvtarGroupComponent from "./AvtarGroupComponent";
import styles from "./BoardCard.module.scss";
import attechIcon from "../../resources/images/attech.svg";
import commentIcon from "../../resources/images/commentCount.svg";
import useModal from "../Hooks/useModal";
import ModalDialog from "../common/Modal/Modal";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ApplicantActions, jobProfileActions } from "../../actions";
import fillFlag from "../../resources/images/fillFlag.svg";
import DetailComponent from "../DetailComponent/DetailComponent";
import { useSelector } from "react-redux";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";

const BoardCard = (props) => {
  const { toggle: BoradDetailsToggle, visible: boardVisible } = useModal();
  const boardData = useSelector(
    (state) => state?.applicant?.boardData?.columns
  );
  const jobProfile = useSelector(
    (state) => state?.applicant?.boardApplicant?.job_profile
  );
  const user = useSelector((state) => state.authentication.user);
  const [deleteId, setDeleteId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [currentModalIndex, setCurrentModalIndex] = useState(null);
  const [selectedRoundCards, setSelectedRoundCards] = useState([]);
  const [selectedRoundCardsLength, setSelectedRoundCardsLength] =
    useState(null);
  const loadingCheck = useSelector((state) => state.applicant.BoardCardLoading);
  const CardClick = () => {
    if (props?.data?.id) {
      dispatch(ApplicantActions.getApplicantStatus(props?.data?.jobId));
      if (user && user.userRole !== 4) {
        // dispatch(jobProfileActions.getAssignee({ "applicationId": props?.data?.id }));
        dispatch(jobProfileActions.getSearchApi());
      }
      dispatch(ApplicantActions.getApplicant(props?.data?.id));
      BoradDetailsToggle();

      let selectedRound = boardData.find(
        (data) => data.title === props?.data?.applicationStatus
      );
      let selectedCardIndex = selectedRound?.cards?.findIndex(
        (data) => data.id === props?.data?.id
      );

      setCurrentModalIndex(selectedCardIndex);
      setSelectedRoundCards(selectedRound?.cards);
      setSelectedRoundCardsLength(selectedRound?.cards?.length - 1);
    }
  };
  const returnAlert = location?.state?.returnAlert;

  useEffect(() => {
    let cardId;
    if (currentModalIndex || currentModalIndex == 0)
      cardId = selectedRoundCards[currentModalIndex]?.id;
    if (cardId) {
      if (user && user.userRole !== 4) {
        dispatch(jobProfileActions.getAssignee({ applicationId: cardId }));
      }
      dispatch(ApplicantActions.getApplicant(cardId));
    }
  }, [currentModalIndex]);

  useEffect(() => {
    if (boardVisible === false) {
      if (returnAlert) {
        navigate("/alerts");
      }
      if (searchParams.has("applicationId")) {
        searchParams.delete("applicationId");
        setSearchParams(searchParams);
      }
      if (searchParams.has("commentId")) {
        searchParams.delete("commentId");
        setSearchParams(searchParams);
      }
      if (searchParams.has("tagged")) {
        searchParams.delete("tagged");
        setSearchParams(searchParams);
      }
      props?.getBoardData({ hideLoader: true });
      setCurrentModalIndex(null);
    }
  }, [boardVisible]);

  useEffect(() => {
    if (props?.data) {
      if (location?.state && location?.state?.applicationId) {
        const myBtn = document.getElementById(
          `BoardCard_${location?.state?.applicationId}`
        );
        myBtn?.click();
      }
    }
  }, [props?.data]);

  useEffect(() => {
    if (searchParams.get("applicationId")) {
      const myBtn = document.getElementById(
        `BoardCard_${searchParams.get("applicationId")}`
      );
      myBtn?.click();
    }
  }, []);

  //props?.removeCard()

  return (
    <div
      className={`${styles.CardPart} ${
        props?.data?.flagged ? styles.activeCard : ""
      }`}
    >
      <div className={styles.CardTitle}>
        <span className={styles.CardHeading}>{props?.data?.title} </span>
        <div className={styles.actionPart}>
          <div className={user && user.userRole !== 4 ? "" : "visually-hidden"}>
            {props?.data?.flagged ? <img src={fillFlag} alt="flag" /> : ""}
            <CardActionMenu
              flag={true}
              row={props?.data}
              setDeleteId={props?.setDeleteId}
              setActiveData={props?.setActiveData}
              setEditedData={props?.setEditedData}
            />
          </div>
        </div>
      </div>
      <div
        className={
          user && user.userRole !== 4
            ? styles.CardBody
            : styles.pointer + " " + styles.CardBody
        }
        id={`BoardCard_${props?.data?.id}`}
        onClick={() => CardClick()}
      >
        <div>
          <div className={`${styles.mainTitlePart} mb-2`}>
            {props?.data?.jobTitle}
          </div>
          <div className={`${styles.titlePart} mb-2`}>
            {props?.data?.jobProfile}
          </div>
          <div className={styles.timePartMain}>
            Added On :{" "}
            <span className={styles.timePart}>{props?.data?.addedOn}</span>
          </div>
        </div>
        <div className={styles.CardFooterPart}>
          <div className={styles.AvatarGroup}>
            <AvtarGroupComponent interviewers={props?.data?.interviewers} />
          </div>
          <div className={styles.attechmentPart}>
            <div className={styles.attech}>
              <img src={attechIcon} alt="attechment" />{" "}
              {props?.data?.attachmentCount}
            </div>
            <div className={styles.divider}></div>
            <div className={styles.attech}>
              <img src={commentIcon} alt="comment" />{" "}
              {props?.data?.commentCount}
            </div>
          </div>
        </div>
      </div>
      {props.data.source === 1 && (
        <span className={`${styles.ribbon}`}>External</span>
      )}
      {props.data.source === 3 && (
        <span className={`${styles.ribbon}`}>Referral</span>
      )}

      <ModalDialog
        toggle={BoradDetailsToggle}
        title={
          jobProfile?.name && `${jobProfile?.name} ${jobProfile?.jobTitle}`
        }
        visible={boardVisible}
        currentModalIndex={currentModalIndex}
        setCurrentModalIndex={setCurrentModalIndex}
        selectedRoundCardsLength={selectedRoundCardsLength}
        showPrevNext={true}
        source={props?.data?.source}
        size="xl"
        bodyClass="p-0"
        loadingCheck={loadingCheck}
      >
        <DetailComponent
          setDeleteId={props?.setDeleteId}
          setActiveData={props?.setActiveData}
          setEditedData={props?.setEditedData}
          getBoardData={props?.getBoardData}
        />
      </ModalDialog>
    </div>
  );
};

export default BoardCard;
